module.exports = __webpack_public_path__ + "gmgn-logo-c706bd95.png";